/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ViewBox from "vux/src/components/view-box/index.vue";
import XInput from "vux/src/components/x-input/index.vue";
import Group from "vux/src/components/group/index.vue";
import XButton from "vux/src/components/x-button/index.vue";
import { mapState, mapMutations } from 'vuex';
import { codeGet, codeLogin, pwdLogin, getSessionUser, updateLocation, getSysPhone, getEnterprise } from '@/api';
export default {
  name: 'codeLogin',
  props: {
    redirect: {
      type: String,
      default: ''
    }
  },
  components: {
    ViewBox: ViewBox,
    XInput: XInput,
    Group: Group,
    XButton: XButton
  },
  data: function data() {
    return {
      psw: 'password',
      flag: true,
      form: {
        mobile: '',
        verify_code: '',
        password: ''
      },
      time: 0,
      code: '发送验证码',
      loading: false,
      title: '登录',
      loginByCode: false
    };
  },
  watch: {
    time: function time(v) {
      if (this.time === 0) {
        this.code = '发送验证码';
        if (this.interval) clearInterval(this.interval);
      } else {
        this.code = "".concat(this.time, "s\u540E\u91CD\u65B0\u53D1\u9001");
      }
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('globalStore', ['user', 'sysPhone'])), mapState('appStore', ['isReadPrivacy'])), {}, {
    loginTypeTitle: function loginTypeTitle() {
      return this.loginByCode ? '切换密码登录' : '切换验证码登录';
    }
  }),
  created: function created() {
    console.log('codeLogin', this);
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations('globalStore', ['_user', '_sysPhone'])), mapMutations('appStore', ['_sessionID', '_isReadPrivacy'])), {}, {
    sendCode: function sendCode() {
      var _this = this;

      if (!this.form.mobile.replace(/\s+/g, '').match(/^(\+?0?86-?)?1[3456789]\d{9}$/)) {
        this.$vux.toast.text('请输入正确的手机号码');
        return;
      }

      this.$http.post('/front/codeContent', {
        phone: this.form.mobile.replace(/\s+/g, '')
      }).then(function (res) {
        if (res.data.code == 0) {
          _this.time = 60;
          _this.interval = setInterval(function () {
            _this.time--;
          }, 1000);

          _this.$vux.toast.text('发送成功');
        } else {
          _this.$vux.toast.text(res.data.msg || '发送失败');
        }
      });
    },
    login: function login() {
      var _this2 = this;

      var form = this.form;
      this.loading = true;
      this.$http.post('/front/codeLogin', {
        phone: form.mobile.replace(/\s+/g, ''),
        code: form.verify_code
      }).then(function (res) {
        _this2.loading = false;

        if (res.data.code == 0) {
          _this2.$vux.toast.text("\u767B\u5F55\u6210\u529F");

          _this2._sessionID(res.data.msg);

          if (res.data.msg) {
            if (_this2.redirect) {
              _this2.$router.replace({
                path: _this2.redirect
              });
            } else {
              _this2.$router.replace({
                name: 'Home'
              });
            }
          } else {
            _this2.$vux.toast.text(res.data.msg || '登录失败');
          }
        } else {
          _this2.$vux.toast.text(res.data.msg || '登录失败');
        }
      });
    },
    submit: function submit() {
      if (this.form.mobile === '') {
        this.$vux.toast.text('手机号不能为空');
        return;
      }

      if (this.form.verify_code === '') {
        this.$vux.toast.text('验证码不能为空');
        return;
      }

      this.login();
    }
  })
};